import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store/index';
import User from '@/utils/User.js';
import Y from '@/utils/Y';
import { SITE_URL, LOGIN_TYPE_PERSONAL, LOGIN_TYPE_ENTERPRISE } from '@/data/siteConfig';
import { goLoginRedirect } from '@/utils/complianceEntry';

import Index from '@/views/index.vue';
//首页
import Home from '@/views/Home/index.vue';
//标准法规
import StandardsList from '@/views/StandardsView/index.vue';
import StandardsDet from '@/views/StandardsView/Det.vue';
// import StandardsPdf from '@/views/StandardsView/Pdf.vue';
// import StandardsDoc from '@/views/StandardsView/Doc.vue';
// import StandardAdvanced from '@/views/Search/StandardAdvanced.vue';
import ScanVerify from '@/views/StandardsView/ScanVerify.vue';
//智能助手
import Ai from '@/views/Ai/index.vue';
//用户信息
import Info from '@/views/Info/Index.vue';
import Guide from '@/components/Guide/index.vue';
//用户中心
import UserCenter from '@/views/UserCenter/Index.vue';
import UserInfo from '@/views/UserCenter/Info.vue';
import UserAccount from '@/views/UserCenter/Account.vue';
import UserAddress from '@/views/UserCenter/Address.vue';
import UserInvoice from '@/views/UserCenter/Invoice.vue';
import UserPoint from '@/views/UserCenter/Point.vue';
import FeedBack from '@/views/UserCenter/FeedBack.vue';
import BookOrder from '@/views/UserCenter/BookOrder.vue';

import VIPOrder from '@/views/UserCenter/VIPOrder.vue';
import Security from '@/views/UserCenter/Security.vue';
import UserBookList from '@/views/UserCenter/BookList.vue';
//购物车
import Cart from '@/views/Cart/index.vue';
import Settle from '@/views/Cart/confirm.vue';
import Payment from '@/views/Order/Payment.vue';
//订单
import OrderDet from '@/views/Order/OrderDet.vue';
//订单支付
import OrderPayment from '@/views/Order/OrderPayment.vue';
import WeChatPay from '@/components/PayPage/WeChatPay.vue';
import AlipayPay from '@/components/PayPage/AlipayPay.vue';
import OfflineTransfer from '@/components/PayPage/OfflineTransfer.vue';
//书单
// import BookIndex from '@/views/Book/Index.vue';
// import BookType from '@/views/Book/Type.vue';
// import BookList from '@/views/Book/BookList.vue';
// import UBookList from '@/views/Book/UBookList.vue';
// import BookCollectList from '@/views/Book/CollectList.vue';
// import BookBuyList from '@/views/Book/BuyList.vue';
// import BookBoard from '@/views/Book/Board.vue';
//登录回调
import LoginWxCallback from '@/components/LoginWxCallback/index.vue';
//VIP
import Version from '@/views/VIP/GoodsList.vue';
//登录
import Login from '@/views/UserCenter/Login.vue';
//强制绑定手机号
import BindPhone from '@/views/UserCenter/BindPhone.vue';
//申请账户
import ApplyAccount from '@/components/ApplyAccount/index.vue';
//正版说明查询
import Checker from '@/views/Order/OrderVerify.vue';
//新闻资讯详情
import NewsDet from '@/views/News/NewsDet.vue';
//新闻资讯列表
import NewsList from '@/views/News/NewsList.vue';
//下载
import Download from '@/views/Download/index.vue';
//测试页面
// import Ceshi from '@/views/ceshi.vue';

Vue.use(VueRouter);

const routes = [
	//登录回调
	{
		path: '/LoginWxCallback',
		name: 'LoginWxCallback',
		component: LoginWxCallback,
		meta: {
			title: '登录回调',
			requirePhone: false
		}
	},

	//登录
	{
		path: '/Login',
		name: 'Login',
		component: Login,
		meta: {
			title: '登录',
			requirePhone: false
		}
	},

	//扫码验真
	{
		path: '/ScanVerify/:tradeNo/:fileName',
		name: 'ScanVerify',
		component: ScanVerify,
		meta: {
			title: '扫码验真',
			requirePhone: false
		}
	},

	//隐私协议
	// {
	// 	path: '/Privacy',
	// 	name: 'Privacy',
	// 	component: () => import('@/views/Info/Privacy.vue'),
	// 	meta: {
	// 		title: '隐私协议',
	// 		requirePhone: false
	// 	}
	// },

	//用户协议
	// {
	// 	path: '/UserAgreement',
	// 	name: 'UserAgreement',
	// 	component: () => import('@/views/Info/Agreement.vue'),
	// 	meta: {
	// 		title: '用户协议',
	// 		requirePhone: false
	// 	}
	// },

	{
		path: '/',
		component: Index,
		children: [
			//下载页面
			{
				path: 'Download',
				name: 'Download',
				component: Download,
				meta: { title: 'App 下载', requirePhone: false }
			},

			//强制绑定手机号
			{
				path: 'BindPhone',
				name: 'BindPhone',
				component: BindPhone,
				meta: {
					title: '绑定手机号',
					requirePhone: false
				}
			},
			//申请账户
			{
				path: 'ApplyAccount',
				name: 'ApplyAccount',
				component: ApplyAccount,
				meta: {
					title: '申请账号',
					requireChooseCorporate: false
				}
			},
			//正版说明查询
			{
				path: 'checker',
				name: 'Checker',
				component: Checker,
				meta: {
					title: '正版说明查询',
					requireChooseCorporate: false
				}
			},
			//新闻资讯列表
			{
				path: 'NewsList',
				name: 'NewsList',
				component: NewsList,
				meta: { title: '新闻资讯', requireChooseCorporate: false }
			},
			//新闻资讯详情
			{
				path: 'NewsDet',
				name: 'NewsDet',
				component: NewsDet,
				meta: { title: '新闻详情', requireChooseCorporate: false }
			},
			//首页
			{
				path: '/Home',
				redirect: '/'
			},
			{
				path: '',
				name: 'Home',
				component: Home,
				meta: {
					title: '首页',
					requirePhone: false
				}
			},
			//标准法规-列表
			{
				path: 'StandardsList',
				name: 'StandardsList',
				component: StandardsList,
				meta: { keepAlive: true, title: '法规标准库', requirePhone: false } // 需要缓存
			},
			//标准法规-高级检索
			// {
			// 	path: 'StandardAdvanced',
			// 	name: 'StandardAdvanced',
			// 	component: StandardAdvanced,
			// 	meta: { keepAlive: true, title: '全国标准信息库高级检索', requirePhone: true } // 需要缓存
			// },
			//标准法规-详情介绍
			{
				path: 'StandardsDet',
				name: 'StandardsDet',
				component: StandardsDet,
				meta: { title: '法规标准详情', requirePhone: false }
			},
			//PDF阅读
			// {
			// 	path: 'StandardsPdf',
			// 	name: 'StandardsPdf',
			// 	component: StandardsPdf,
			// 	meta: { title: 'PDF阅读', requirePhone: true }
			// },
			//结构化阅读
			// {
			// 	path: 'StandardsDoc',
			// 	name: 'StandardsDoc',
			// 	component: StandardsDoc,
			// 	meta: { title: '结构化阅读', requirePhone: true }
			// },
			//ai页面
			{
				path: 'Ai',
				name: 'Ai',
				component: Ai,
				meta: { title: 'AI行业大模型', requirePhone: true }
			},
			//书单
			// {
			// 	path: 'BookCenter',
			// 	name: 'BookIndex',
			// 	component: BookIndex,
			// 	children: [
			// 		{
			// 			path: 'BookBoard',
			// 			name: 'BookBoard',
			// 			component: BookBoard,
			// 			meta: { title: '书架', requirePhone: true }
			// 		},
			// 		{
			// 			path: 'Type',
			// 			name: 'BookType',
			// 			component: BookType,
			// 			meta: { title: '分类', requirePhone: true }
			// 		},
			// 		{
			// 			path: 'BookList',
			// 			name: 'BookList',
			// 			component: BookList,
			// 			meta: { title: '书架列表', requirePhone: true }
			// 		},
			// 		{
			// 			path: 'UBookList',
			// 			name: 'UBookList',
			// 			component: UBookList,
			// 			meta: { title: '我的书单', requirePhone: true }
			// 		},
			// 		{
			// 			path: 'CollectList',
			// 			name: 'BookCollectList',
			// 			component: BookCollectList,
			// 			meta: { title: '收藏夹', requirePhone: true }
			// 		},
			// 		{
			// 			path: 'BuyList',
			// 			name: 'BookBuyList',
			// 			component: BookBuyList,
			// 			meta: { title: '购买书单', requirePhone: true }
			// 		}
			// 	]
			// },
			//footer跳转信息
			{
				path: 'info',
				name: 'Info',
				component: Info,
				meta: { title: '信息', requirePhone: false }
			},
			//操作说明
			{
				path: 'guide',
				name: 'Guide',
				component: Guide,
				meta: { title: '操作说明', requirePhone: false }
			},
			//购物车
			{
				path: 'Cart',
				name: 'Cart',
				component: Cart,
				meta: { title: '购物车', requirePhone: true }
			},
			{
				path: 'Settle',
				name: 'Settle',
				component: Settle,
				meta: { title: '商品结算', requirePhone: true }
			},
			{
				path: 'Payment',
				name: 'Payment',
				component: Payment,
				meta: { title: '支付', requirePhone: true }
			},
			{
				path: 'OrderDet',
				name: 'OrderDet',
				component: OrderDet,
				meta: { title: '订单详情', requirePhone: true }
			},
			{
				path: 'OrderPayment',
				name: 'OrderPayment',
				component: OrderPayment,
				meta: { title: '订单支付', requirePhone: true }
			},
			//微信支付
			{
				path: 'WeChatPay',
				name: 'WeChatPay',
				component: WeChatPay,
				meta: { title: '微信支付', requirePhone: true }
			},
			//支付宝支付
			{
				path: 'AlipayPay',
				name: 'AlipayPay',
				component: AlipayPay,
				meta: { title: '支付宝支付', requirePhone: true }
			},
			//对公转账
			{
				path: 'OfflineTransfer',
				name: 'OfflineTransfer',
				component: OfflineTransfer,
				meta: { title: '对公转账', requirePhone: true }
			},
			//vip信息
			{
				path: 'Version',
				name: 'Version',
				component: Version,
				meta: { title: 'VIP商品', requirePhone: false }
			},
			//测试页面
			// {
			// 	path: 'ceshi',
			// 	name: 'Ceshi',
			// 	component: Ceshi
			// },
			{
				path: 'UserCenter',
				component: UserCenter,
				children: [
					{
						path: 'UserInfo',
						name: 'UserInfo',
						component: UserInfo,
						meta: { title: '个人中心', requirePhone: true }
					},
					{
						path: 'UserAccount',
						name: 'UserAccount',
						component: UserAccount,
						meta: { title: '基本信息', requirePhone: true }
					},
					{
						path: 'UserAddress',
						name: 'UserAddress',
						component: UserAddress,
						meta: { title: '用户地址', requirePhone: true }
					},
					{
						path: 'UserInvoice',
						name: 'UserInvoice',
						component: UserInvoice,
						meta: { title: '用户发票', requirePhone: true }
					},
					{
						path: 'UserPoint',
						name: 'UserPoint',
						component: UserPoint,
						meta: { title: '用户积分', requirePhone: true }
					},
					{
						path: 'BookOrder',
						name: 'BookOrder',
						component: BookOrder,
						meta: { title: '用户书单订单', requirePhone: true }
					},
					{
						path: 'VIPOrder',
						name: 'VIPOrder',
						component: VIPOrder,
						meta: { title: '用户VIP订单', requirePhone: true }
					},
					{
						path: 'UserBookList',
						name: 'UserBookList',
						component: UserBookList,
						meta: { title: '用户书单', requirePhone: true }
					},

					{
						path: 'Security',
						name: 'Security',
						component: Security,
						meta: { title: '账号安全', requirePhone: true }
					},
					{
						path: 'FeedBack',
						name: 'FeedBack',
						component: FeedBack,
						meta: { title: '用户反馈', requirePhone: false }
					}
				]
			}
		]
	}
];

const createRouter = () =>
	new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (to.hash) {
				return {
					selector: to.hash,
					offset: { x: 0, y: 80 }
				};
			}
			return { x: 0, y: 0, behavior: 'smooth' };
		}
	});

const router = createRouter();

// 路由守卫
router.beforeEach(async (to, from, next) => {
	// ===== 退出登录回调：子域名退出后清除主域名所有缓存 =====
	if (to.query.logout === '1') {
		User.logout();
		// 同步清除 Vuex
		store.commit('User/setToken', '');
		store.commit('User/setInfo', { id: 0 });
		store.commit('User/setCorporate', {});
		store.commit('User/setCorporateList', []);
		store.dispatch('Settings/setPendingCompanyList', []);
		store.dispatch('Settings/setCompanySelectorShow', false);
		const cleanQuery = { ...to.query };
		delete cleanQuery.logout;
		next({ path: to.path, query: cleanQuery, replace: true });
		return;
	}
	// ===== 结束 =====

	// ===== 总入口：已登录用户自动重定向到对应子域名 =====
	// 若智能工具点击留有“待打开合规系统”标记，先由总入口判定账户等级，有权限则直跳合规系统
	const loginType = User.getLoginType();
	const token = User.getToken();
	if (token && loginType && to.name !== 'Login' && to.name !== 'LoginWxCallback' && to.name !== 'ScanVerify') {
		if (loginType === LOGIN_TYPE_PERSONAL) {
			await goLoginRedirect(SITE_URL.PERSON, token);
			return;
		} else if (loginType === LOGIN_TYPE_ENTERPRISE) {
			const cinfo = User.getCorporate();
			if (cinfo && cinfo.corporateId) {
				// 已选企业：携带 token + 企业信息跳转
				await goLoginRedirect(SITE_URL.COMPANY, token, cinfo);
				return;
			}
			// 未选企业（多企业场景刷新页面）：留在主入口，触发企业选择弹窗
			const corporateList = User.getCorporateList();
			if (corporateList && corporateList.length > 0) {
				store.dispatch('Settings/setPendingCompanyList', corporateList);
				store.dispatch('Settings/setCompanySelectorShow', true);
			}
			// 不 return，继续正常路由（PageHeader 会弹出选择窗）
		}
	}
	// ===== 结束 =====

	// ===== 跨子域 token 接收：来自企业版的 URL 参数 tk =====
	const urlTk = to.query.tk;
	if (urlTk && !User.getToken()) {
		User.setToken(urlTk);
		store.commit('User/setToken', urlTk);
		// 清除 URL 中的 tk 参数，防止泄露
		const cleanQuery = { ...to.query };
		delete cleanQuery.tk;
		next({ path: to.path, query: cleanQuery, replace: true });
		return;
	}
	// ===== 结束 =====

	// let tk = User.getToken();
	// let userInfo = null;

	// 如果用户已登录，获取用户信息
	// if (tk) {
	// 	try {
	// 		userInfo = await store.dispatch('User/getUserInfo');
	// 		if (userInfo.data.delFlag == 2) {
	// 			//退出登录
	// 			console.log('用户已删除，退出登录');
	// 			store.dispatch('User/logout');
	// 		}
	// 	} catch (error) {
	// 		console.error('获取用户信息失败:', error);
	// 	}
	// }

	// 校验需要手机号的页面
	// const requirePhone = to.matched.some(record => record.meta.requirePhone);

	// if (tk && userInfo && !userInfo.data.consumerPhone && requirePhone) {
	// 	Y.msg.warning('请先绑定手机号');
	// 	next({ path: '/BindPhone', replace: true });
	// 	return;
	// }

	// 设置页面标题
	if (to.name === 'StandardsDet' || to.name === 'StandardsPdf' || to.name === 'StandardsDoc' || to.name === 'Info') {
		// Det.vue页面会在组件内部设置自己的标题，这里不做处理, 需要有文件信息
		next();
	} else if (to.name === 'Home') {
		// 首页设置特殊标题
		store.dispatch('Settings/setCurrentTitle', `特规通-特种设备行业法规标准与AI知识服务平台`)
		next()
	} else {
		// 其他所有页面统一设置为meta中的title
		store.dispatch('Settings/setCurrentTitle', `${to.meta.title} - 特规通`);
		next();
	}
});

// 解决重复点击导航时，控制台出现报错
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
	return VueRouterPush.call(this, to).catch(err => err);
};
const VueRouterReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(to) {
	return VueRouterReplace.call(this, to).catch(err => err);
};

export function resetRouter() {
	const newRouter = createRouter();
	router.matcher = newRouter.matcher; // reset router
}

export default router;
